import { useEffect } from 'react';

const useTiktokPixel = (pixelId) => {
  useEffect(() => {
    // Load the TikTok Pixel script dynamically
    const script = document.createElement('script');
    script.src = `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${pixelId}&lib=ttq`;
    script.async = true;
    script.onload = () => {
      // Initialize the pixel once the script is loaded
      window.ttq = window.ttq || [];
      window.ttq.load = function (e, n) {
        window.ttq._i = window.ttq._i || {};
        window.ttq._i[e] = [];
        window.ttq._i[e]._u = `https://analytics.tiktok.com/i18n/pixel/events.js`;
        window.ttq._t = window.ttq._t || {};
        window.ttq._t[e] = +new Date();
        window.ttq._o = window.ttq._o || {};
        window.ttq._o[e] = n || {};
      };

      // Track page view after loading
      window.ttq.page();
    };

    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(script);
    };
  }, [pixelId]);
};

export default useTiktokPixel;
